import React from "react";
var uuidv1 = require('uuid/v1');

export const deleteDayFromProgram = (programObj, new_day_id) => { // programObj, block_id, set_id
        var ctr = 0;
        var tmpObj = {}
        //console.log("BEGIN DELETE DAY() !!!");
        // Assign old object to new tmp object and delete Exercise sub-object
        for(var key in programObj) {
                var value  = programObj[key];
                var day_id = value.day_id;

                if(day_id != new_day_id) {
                        tmpObj[ctr] = {};
                        tmpObj[ctr].week_id       = value.week_id;
                        tmpObj[ctr].week_order    = value.week_order;
                        tmpObj[ctr].day_id        = day_id;
                        tmpObj[ctr].day_order     = value.day_order;
                        tmpObj[ctr].block_order   = value.block_order;
                        tmpObj[ctr].block_id      = value.block_id;
                        tmpObj[ctr].block_name    = value.block_name;
                        tmpObj[ctr].exercise      = {};

                        var nctr = 0;
                        var exercise = value.exercise;

                        for(var key2 in exercise) {
                            var exer            = exercise[key2];
                            var exer_name       = exer.name;
                            var exer_id         = exer.id;
                            var set_id          = exer.set_id;
                            var exer_order      = exer.order;
                            var rest            = exer.rest;
                            var notes           = exer.notes;

                            var advanced_metrics = exer.advanced_metrics;
                            var row_1_id   = exer.row_1_id;
                            var row_2_id   = exer.row_2_id;
                            var row_3_id   = exer.row_3_id;
                            var row_4_id   = exer.row_4_id;
                            var row_1_arr  = exer.row_1_arr;
                            var row_2_arr  = exer.row_2_arr;
                            var row_3_arr  = exer.row_3_arr;
                            var row_4_arr  = exer.row_4_arr;

                            tmpObj[ctr].exercise[nctr]                 = {};
                            tmpObj[ctr].exercise[nctr].id              = exer_id;
                            tmpObj[ctr].exercise[nctr].name            = exer_name;
                            tmpObj[ctr].exercise[nctr].order           = exer_order;
                            tmpObj[ctr].exercise[nctr].set_id          = set_id;
                            tmpObj[ctr].exercise[nctr].rest            = rest;
                            tmpObj[ctr].exercise[nctr].notes           = notes;
                            tmpObj[ctr].exercise[nctr].order           = nctr; // add new "order" field
                            // ADVANCED VIEW //
                            tmpObj[ctr].exercise[nctr].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
                            tmpObj[ctr].exercise[nctr].row_1_id         = row_1_id;
                            tmpObj[ctr].exercise[nctr].row_2_id         = row_2_id;
                            tmpObj[ctr].exercise[nctr].row_3_id         = row_3_id;
                            tmpObj[ctr].exercise[nctr].row_4_id         = row_4_id;
                            tmpObj[ctr].exercise[nctr].row_1_arr        = row_1_arr;
                            tmpObj[ctr].exercise[nctr].row_2_arr        = row_2_arr;
                            tmpObj[ctr].exercise[nctr].row_3_arr        = row_3_arr;
                            tmpObj[ctr].exercise[nctr].row_4_arr        = row_4_arr;
                            nctr++;
                        }
                        //console.log("-------------------");
                        tmpObj[ctr].exercise_lgth  = nctr;

                        ctr++;
                }
        }

        return tmpObj;
}

//// REWROTE APRIL 19th; below should be Set Id not Ex Id!!!
export const deleteExerciseFromProgram = (programObj, new_set_id, exercise_to_index) => { // programObj, block_id, set_id
        var ctr = 0;
        var tmpObj = {}
        var tmpSingleObj = {};
        console.log("BEGIN delete exercise() !!!");

        // Assign old object to new tmp object and delete Exercise sub-object
        for(var key in programObj) {
            tmpObj[ctr] = {};
            tmpObj[ctr].week_id       = programObj[key].week_id;
            tmpObj[ctr].week_order    = programObj[key].week_order;
            tmpObj[ctr].day_id        = programObj[key].day_id;
            tmpObj[ctr].day_order     = programObj[key].day_order;
            tmpObj[ctr].block_order   = programObj[key].block_order;
            tmpObj[ctr].block_id      = programObj[key].block_id;
            tmpObj[ctr].block_name    = programObj[key].block_name;
            tmpObj[ctr].exercise      = {};

            var nctr = 0;
            var exercise = programObj[key].exercise;

            for(var key2 in exercise) {
                var exer            = exercise[key2];
                var exer_name       = exer.name;
                var exer_id         = exer.id;
                var set_id          = exer.set_id;
                var exer_order      = exer.order;
                var measure_a_id    = exer.measure_a_id;
                var measure_a_value = exer.measure_a_value;
                var measure_b_id    = exer.measure_b_id;
                var measure_b_value = exer.measure_b_value;
                var rest            = exer.rest;
                var notes           = exer.notes;

                var advanced_metrics = exer.advanced_metrics;
                var row_1_id   = exer.row_1_id;
                var row_2_id   = exer.row_2_id;
                var row_3_id   = exer.row_3_id;
                var row_4_id   = exer.row_4_id;
                var row_1_arr  = exer.row_1_arr;
                var row_2_arr  = exer.row_2_arr;
                var row_3_arr  = exer.row_3_arr;
                var row_4_arr  = exer.row_4_arr;

                //if(block_id === tmp_block_id && set_id === set_id) {
                //console.log("set_id: " + set_id);
                if(set_id === new_set_id && exercise_to_index != key2) {

                        // There will always be 2 blocks with the same set ids if the  exercises
                        // are dragged into 2 different blocks.
                        if(advanced_metrics != undefined) {
                            //// COPY PROPERTIES INTO NEW TEMP OBJECT ////
                            tmpSingleObj.id              = exer_id;
                            tmpSingleObj.name            = exer_name;
                            tmpSingleObj.order           = exer_order;
                            tmpSingleObj.set_id          = set_id;
                            tmpSingleObj.rest            = rest;
                            tmpSingleObj.notes           = notes;
                            tmpSingleObj.order           = nctr; // add new "order" field
                            // ADVANCED VIEW //
                            tmpSingleObj.advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
                            tmpSingleObj.row_1_id         = row_1_id;
                            tmpSingleObj.row_2_id         = row_2_id;
                            tmpSingleObj.row_3_id         = row_3_id;
                            tmpSingleObj.row_4_id         = row_4_id;
                            tmpSingleObj.row_1_arr        = row_1_arr;
                            tmpSingleObj.row_2_arr        = row_2_arr;
                            tmpSingleObj.row_3_arr        = row_3_arr;
                            tmpSingleObj.row_4_arr        = row_4_arr;
                        }
                        /*tmpObj[ctr].exercise[nctr]                 = {};
                        tmpObj[ctr].exercise[nctr].id              = exer_id;
                        tmpObj[ctr].exercise[nctr].name            = exer_name;
                        tmpObj[ctr].exercise[nctr].order           = exer_order;
                        tmpObj[ctr].exercise[nctr].set_id          = set_id;
                        tmpObj[ctr].exercise[nctr].rest            = rest;
                        tmpObj[ctr].exercise[nctr].notes           = notes;
                        tmpObj[ctr].exercise[nctr].order           = nctr; // add new "order" field
                        // ADVANCED VIEW //
                        tmpObj[ctr].exercise[nctr].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
                        tmpObj[ctr].exercise[nctr].row_1_id         = row_1_id;
                        tmpObj[ctr].exercise[nctr].row_2_id         = row_2_id;
                        tmpObj[ctr].exercise[nctr].row_3_id         = row_3_id;
                        tmpObj[ctr].exercise[nctr].row_4_id         = row_4_id;
                        tmpObj[ctr].exercise[nctr].row_1_arr        = row_1_arr;
                        tmpObj[ctr].exercise[nctr].row_2_arr        = row_2_arr;
                        tmpObj[ctr].exercise[nctr].row_3_arr        = row_3_arr;
                        tmpObj[ctr].exercise[nctr].row_4_arr        = row_4_arr;
                        nctr++;*/
                        // Do not assign selected object to new TmpObj
                        // temp: eventually save the removed property from the
                        // obj to let the user "go back" in history
                } else {
                        //console.log(key2 + ". DON't DELETE exer_name: " + exer_name);
                        //console.log("exer_id: " + exer_id);
                        tmpObj[ctr].exercise[nctr]                 = {};
                        tmpObj[ctr].exercise[nctr].id              = exer_id;
                        tmpObj[ctr].exercise[nctr].name            = exer_name;
                        tmpObj[ctr].exercise[nctr].order           = exer_order;
                        tmpObj[ctr].exercise[nctr].set_id          = set_id;
                        tmpObj[ctr].exercise[nctr].rest            = rest;
                        tmpObj[ctr].exercise[nctr].notes           = notes;
                        tmpObj[ctr].exercise[nctr].order           = nctr; // add new "order" field
                        // ADVANCED VIEW //
                        tmpObj[ctr].exercise[nctr].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
                        tmpObj[ctr].exercise[nctr].row_1_id         = row_1_id;
                        tmpObj[ctr].exercise[nctr].row_2_id         = row_2_id;
                        tmpObj[ctr].exercise[nctr].row_3_id         = row_3_id;
                        tmpObj[ctr].exercise[nctr].row_4_id         = row_4_id;
                        tmpObj[ctr].exercise[nctr].row_1_arr        = row_1_arr;
                        tmpObj[ctr].exercise[nctr].row_2_arr        = row_2_arr;
                        tmpObj[ctr].exercise[nctr].row_3_arr        = row_3_arr;
                        tmpObj[ctr].exercise[nctr].row_4_arr        = row_4_arr;
                        nctr++;
                }
            }
            //console.log("-------------------");
            tmpObj[ctr].exercise_lgth  = nctr;

            ctr++;
        }
        var mainObj = {};

        mainObj.tmpSingleObj = tmpSingleObj;
        mainObj.tmpObj       = tmpObj;

        return mainObj;
}

export const deleteExerciseObjectProps = (programObj, block_id, new_set_id) => { //// 3/13 :removed block_index: (programObj, block_index, block_id, exercise_index)
        var ctr = 0;
        var tmpObj = {}
        //console.log("BEGIN deleteExerciseObjectProps() !!!");
        // Assign old object to new tmp object and delete Exercise sub-object
        for(var key in programObj) {
            var tmp_block_id          = programObj[key].block_id;
            tmpObj[ctr] = {};
            tmpObj[ctr].week_id       = programObj[key].week_id;
            tmpObj[ctr].day_id        = programObj[key].day_id;
            tmpObj[ctr].block_order   = programObj[key].block_order;
            //tmpObj[ctr].category_id   = programObj[key].category_id;
            tmpObj[ctr].block_id      = tmp_block_id;
            tmpObj[ctr].block_name    = programObj[key].block_name;
            tmpObj[ctr].exercise      = {};

            var nctr = 0;
            var exercise = programObj[key].exercise;

            for(var key2 in exercise) {
                var exer            = exercise[key2];
                var exer_name       = exer.name;
                var exer_id         = exer.id;
                var set_id          = exer.set_id;
                var measure_a_id    = exer.measure_a_id;
                var measure_a_value = exer.measure_a_value;
                var measure_b_id    = exer.measure_b_id;
                var measure_b_value = exer.measure_b_value;
                var rest            = exer.rest;
                var notes           = exer.notes;

                var advanced_metrics = exer.advanced_metrics;
                var row_1_id   = exer.row_1_id;
                var row_2_id   = exer.row_2_id;
                var row_3_id   = exer.row_3_id;
                var row_4_id   = exer.row_4_id;
                var row_1_arr  = exer.row_1_arr;
                var row_2_arr  = exer.row_2_arr;
                var row_3_arr  = exer.row_3_arr;
                var row_4_arr  = exer.row_4_arr;
                //console.log("ctr: " + ctr);

                if(block_id === tmp_block_id && set_id === new_set_id) {
                        //if(key == block_index && key2 == exercise_index) {
                        //console.log("exercise_index: " + exercise_index);

                        // Do not assign selected object to new TmpObj
                        // temp: eventually save the removed property from the
                        // obj to let the user "go back" in history
                } else {
                        //console.log(key2 + ". DON't DELETE exer_name: " + exer_name);
                        //console.log("exer_id: " + exer_id);
                        tmpObj[ctr].exercise[nctr]                 = {};
                        tmpObj[ctr].exercise[nctr].id              = exer_id;
                        tmpObj[ctr].exercise[nctr].name            = exer_name;
                        tmpObj[ctr].exercise[nctr].set_id          = set_id;
                        tmpObj[ctr].exercise[nctr].measure_a_id    = measure_a_id;
                        tmpObj[ctr].exercise[nctr].measure_a_value = measure_a_value;
                        tmpObj[ctr].exercise[nctr].measure_b_id    = measure_b_id;
                        tmpObj[ctr].exercise[nctr].measure_b_value = measure_b_value;
                        tmpObj[ctr].exercise[nctr].rest            = rest;
                        tmpObj[ctr].exercise[nctr].notes           = notes;
                        tmpObj[ctr].exercise[nctr].order           = nctr; // add new "order" field
                        // ADVANCED VIEW //
                        tmpObj[ctr].exercise[nctr].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
                        tmpObj[ctr].exercise[nctr].row_1_id         = row_1_id;
                        tmpObj[ctr].exercise[nctr].row_2_id         = row_2_id;
                        tmpObj[ctr].exercise[nctr].row_3_id         = row_3_id;
                        tmpObj[ctr].exercise[nctr].row_4_id         = row_4_id;
                        tmpObj[ctr].exercise[nctr].row_1_arr        = row_1_arr;
                        tmpObj[ctr].exercise[nctr].row_2_arr        = row_2_arr;
                        tmpObj[ctr].exercise[nctr].row_3_arr        = row_3_arr;
                        tmpObj[ctr].exercise[nctr].row_4_arr        = row_4_arr;
                        nctr++;
                }
            }
            console.log("-------------------");
            tmpObj[ctr].exercise_lgth  = nctr;

            ctr++;
        }

        return tmpObj;
}

export const addSingleBlockToProgram = (blockObj, programObj) => {
    //console.log("++++++++  addSingleBlockToProgram  >>>>>>>>>>>");
    var block_lgth  = Object.keys(programObj).length;
    var block_order = block_lgth+1;

    var exercise = blockObj[0].exercise;
    var exercise_lgth = blockObj[0].exercise_lgth;

    // Add next Block in the object's order //
    var tmpBlockObj = {};
    tmpBlockObj[block_lgth] = {};
    //tmpBlockObj[block_lgth].category_id   = programObj[index].category_id;
    tmpBlockObj[block_lgth].block_id      = uuidv1();
    tmpBlockObj[block_lgth].block_order   = block_order;
    //tmpBlockObj[block_lgth].block_name    = programObj[index].block_name;
    //tmpBlockObj[block_lgth].exercise_lgth = programObj[index].exercise_lgth;
    tmpBlockObj[block_lgth].block_name    = blockObj[0].block_name;
    tmpBlockObj[block_lgth].exercise_lgth = exercise_lgth;
    tmpBlockObj[block_lgth].exercise      = {}; // new blocks need a default "exercise" property


    for(var k=0; k < exercise_lgth; k++) {
        var exer = exercise[k];
        var exer_name = exer.name;
        var exer_id   = exer.id;
        var set_id    = uuidv1();

        var rest             = exer.rest;
        var notes            = exer.notes;
        var advanced_metrics = exer.advanced_metrics;
        var row_1_id         = exer.row_1_id;
        var row_2_id         = exer.row_2_id;
        var row_3_id         = exer.row_3_id;
        var row_4_id         = exer.row_4_id;
        var row_1_arr        = exer.row_1_arr;
        var row_2_arr        = exer.row_2_arr;
        var row_3_arr        = exer.row_3_arr;
        var row_4_arr        = exer.row_4_arr;

        tmpBlockObj[block_lgth].exercise[k]         = {};
        tmpBlockObj[block_lgth].exercise[k].id      = exer_id;
        tmpBlockObj[block_lgth].exercise[k].name    = exer_name;
        tmpBlockObj[block_lgth].exercise[k].set_id  = set_id;
        /*tmpBlockObj[block_lgth].exercise[k].measure_a_id    = measure_a_id;
        tmpBlockObj[block_lgth].exercise[k].measure_a_value = measure_a_value;
        tmpBlockObj[block_lgth].exercise[k].measure_b_id    = measure_b_id;
        tmpBlockObj[block_lgth].exercise[k].measure_b_value = measure_b_value;*/
        tmpBlockObj[block_lgth].exercise[k].rest            = rest;
        tmpBlockObj[block_lgth].exercise[k].notes           = notes;
        tmpBlockObj[block_lgth].exercise[k].order           = (k+1);
        // ADVANCED VIEW //
        tmpBlockObj[block_lgth].exercise[k].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
        tmpBlockObj[block_lgth].exercise[k].row_1_id         = row_1_id;
        tmpBlockObj[block_lgth].exercise[k].row_2_id         = row_2_id;
        tmpBlockObj[block_lgth].exercise[k].row_3_id         = row_3_id;
        tmpBlockObj[block_lgth].exercise[k].row_4_id         = row_4_id;
        tmpBlockObj[block_lgth].exercise[k].row_1_arr        = row_1_arr;
        tmpBlockObj[block_lgth].exercise[k].row_2_arr        = row_2_arr;
        tmpBlockObj[block_lgth].exercise[k].row_3_arr        = row_3_arr;
        tmpBlockObj[block_lgth].exercise[k].row_4_arr        = row_4_arr;

        /*console.log("row_1_arr: " + row_1_arr);
        console.log("row_2_arr: " + row_2_arr);
        console.log("row_3_arr: " + row_3_arr);
        console.log("row_4_arr: " + row_4_arr);
        console.log("set_id: " + set_id);
        console.log("exer_name: " + exer_name);
        console.log("exer_id: " + exer_id);
        console.log("------------------");*/
    }

    return tmpBlockObj;
}

export const duplicateBlock = (index, programObj) => {
    var block_lgth  = Object.keys(programObj).length;
    var block_order = block_lgth+1;
    var exercise = programObj[index].exercise;
    // temp for category name creation
    var tmp = Math.ceil(Math.random() * (Math.ceil(6) - Math.floor(1)));

    // Add next Block in the object's order //
    var tmpBlockObj = {};
    tmpBlockObj[block_lgth] = {};
    //tmpBlockObj[block_lgth].category_id   = programObj[index].category_id;
    tmpBlockObj[block_lgth].block_id      = uuidv1();
    tmpBlockObj[block_lgth].block_order   = block_order;
    tmpBlockObj[block_lgth].block_name    = programObj[index].block_name;
    tmpBlockObj[block_lgth].exercise_lgth = programObj[index].exercise_lgth;
    tmpBlockObj[block_lgth].exercise      = {}; // new blocks need a default "exercise" property

    var ctr = 0;
    for(var key2 in exercise) {
        var exer = exercise[key2];
        var exer_name = exer.name;
        var exer_id   = exer.id;
        var set_id    = uuidv1(); // need new set id: exer.set_id;

        var rest             = exer.rest;
        var notes            = exer.notes;

        var advanced_metrics = exer.advanced_metrics;
        var row_1_id         = exer.row_1_id;
        var row_2_id         = exer.row_2_id;
        var row_3_id         = exer.row_3_id;
        var row_4_id         = exer.row_4_id;
        var row_1_arr        = exer.row_1_arr;
        var row_2_arr        = exer.row_2_arr;
        var row_3_arr        = exer.row_3_arr;
        var row_4_arr        = exer.row_4_arr;

        /*console.log("row_1_arr: " + row_1_arr);
        console.log("row_2_arr: " + row_2_arr);
        console.log("row_3_arr: " + row_3_arr);
        console.log("row_4_arr: " + row_4_arr);*/

        tmpBlockObj[block_lgth].exercise[ctr]         = {};
        tmpBlockObj[block_lgth].exercise[ctr].id      = exer_id;
        tmpBlockObj[block_lgth].exercise[ctr].name    = exer_name;
        tmpBlockObj[block_lgth].exercise[ctr].set_id  = set_id;
        /*tmpBlockObj[block_lgth].exercise[ctr].measure_a_id    = measure_a_id;
        tmpBlockObj[block_lgth].exercise[ctr].measure_a_value = measure_a_value;
        tmpBlockObj[block_lgth].exercise[ctr].measure_b_id    = measure_b_id;
        tmpBlockObj[block_lgth].exercise[ctr].measure_b_value = measure_b_value;*/
        tmpBlockObj[block_lgth].exercise[ctr].rest            = rest;
        tmpBlockObj[block_lgth].exercise[ctr].notes           = notes;
        tmpBlockObj[block_lgth].exercise[ctr].order           = (ctr+1);
        // ADVANCED VIEW //
        tmpBlockObj[block_lgth].exercise[ctr].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
        tmpBlockObj[block_lgth].exercise[ctr].row_1_id         = row_1_id;
        tmpBlockObj[block_lgth].exercise[ctr].row_2_id         = row_2_id;
        tmpBlockObj[block_lgth].exercise[ctr].row_3_id         = row_3_id;
        tmpBlockObj[block_lgth].exercise[ctr].row_4_id         = row_4_id;
        tmpBlockObj[block_lgth].exercise[ctr].row_1_arr        = row_1_arr;
        tmpBlockObj[block_lgth].exercise[ctr].row_2_arr        = row_2_arr;
        tmpBlockObj[block_lgth].exercise[ctr].row_3_arr        = row_3_arr;
        tmpBlockObj[block_lgth].exercise[ctr].row_4_arr        = row_4_arr;
        ctr++;
    }

    return tmpBlockObj;
}

export const duplicateBlockObjectFromMonthView = (week_id, day_id, block_id, block_name, total_blocks, programObj) => {
        var block_lgth  = Object.keys(programObj).length;
        var block_order = total_blocks+1;
        var index = 0; //temp
        // temp for category name creation
        var tmp = Math.ceil(Math.random() * (Math.ceil(6) - Math.floor(1)));

        //console.log(">>>>>>>>>>>>>>> DUPLICATE BLOCK ORDER  <<<<<<<<<<<<<<<<<<<");

        var ctr = 0;
        var tmpObj           = programObj;
        var tmpBlockObj      = {};
        var new_block_id     = uuidv1();
        var set_id_order_arr = [];

        ////  Change Block Name to "Block " + Next Block #
        var block_arr = block_name.split(" ", 2); // Split Block Name up into array els; ie if Block 1, dupe to Block 2
        var check_int = parseInt(block_arr[1]);

        if(block_name == null || block_name == "" || (block_arr[0] === "Block" && check_int > 0))
            block_name = "Block " + block_order;

        tmpObj[block_lgth] = {};//tmpBlockObj[ctr];
        tmpObj[block_lgth].week_id       = week_id;
        //tmpObj[block_lgth].week_order  = week_order; // do we need this?

        tmpObj[block_lgth].day_id        = day_id;
        //tmpObj[block_lgth].day_order   = day_order;
        tmpObj[block_lgth].block_order   = block_order;

        tmpObj[block_lgth].block_id      = new_block_id;
        tmpObj[block_lgth].block_name    = block_name; //programObj[index].block_name;
        tmpObj[block_lgth].exercise      = {}; // new blocks need a default "exercise" property

        /*console.log("week_id: " + week_id);
        console.log("day_id: " + day_id);
        console.log("block_lgth: " + block_lgth);
        console.log("block_order: " + block_order);
        console.log("new_block_id: " + new_block_id);
        console.log("block_name: " + block_name);
        console.log("BEGIN FOR LOOP ....");*/
        for(var key in programObj) {

                var tmp_block_id = programObj[key].block_id;
                //var week_id  = programObj[key].week_id;

                if(block_id === tmp_block_id) {
                    var exercise = programObj[key].exercise;
                    var ctr2 = 0;
                    tmpObj[block_lgth].exercise_lgth = programObj[key].exercise_lgth;
                    //console.log("programObj[key].exercise_lgth: " + programObj[key].exercise_lgth);
                    for(var key2 in exercise) {
                        var exer = exercise[key2];
                        var exer_name        = exer.name;
                        var exer_id          = exer.id;
                        var set_id           = uuidv1(); // need new set id: exer.set_id;
                        var notes            = exer.notes;
                        var order            = ctr2+1;

                        /*console.log(key2 + ". order: " + order);
                        console.log("exer: " + exer);
                        console.log("set_id: " + set_id);
                        console.log("exer_id: " + exer_id);
                        console.log("exer_name: " + exer_name);
                        console.log("order: " + order);*/
                        //console.log(key2 + ". set_id: " + set_id);
                        //tmpObj[ctr].exercise               = {};
                        tmpObj[block_lgth].exercise[ctr2]         = {};
                        tmpObj[block_lgth].exercise[ctr2].id      = exer_id;
                        tmpObj[block_lgth].exercise[ctr2].name    = exer_name;
                        tmpObj[block_lgth].exercise[ctr2].set_id  = set_id;
                        tmpObj[block_lgth].exercise[ctr2].notes   = notes;
                        tmpObj[block_lgth].exercise[ctr2].order   = order;

                        set_id_order_arr.push(set_id);
                        ctr2++;
                    }/* end for loop*/
                } // end if loop
                //ctr++;
        }
        var tmp_obj = {};
        tmp_obj.new_block_id     = new_block_id;
        tmp_obj.tmpObj           = tmpObj;
        tmp_obj.block_order      = block_order;
        tmp_obj.set_id_order_arr = set_id_order_arr
        //console.log("1. set_id_order_arr: " + set_id_order_arr);

        return tmp_obj;
}

export const checkIfSingleBlockObjectExistsInDay = (programObj, new_day_id, new_block_id) => {
    var total_blocks = 0;
    //// BEFORE REMOVING THE BLOCK ID, ENSURE THERE IS AT LEAST ONE BLOCK IN THE DAY ////
    for(var key in programObj) {
            var value        = programObj[key];
            var day_id       = value.day_id;
            var block_id     = value.block_id;

            if(new_day_id === day_id) total_blocks++;
    }

    return total_blocks;
}

export const deleteBlockObjectFromMonthView = (programObj, block_id) => {
    var ctr             = 0;
    var block_order_ctr = 1;
    var tmpObj          = {};
    var tmp_day_order   = 0;
    //console.log("BEGIN DELETE BLOCK ORDER!!! >>>>>>>>>>>>>>>>>>>");
    for(var key in programObj) {
            var tmp_block_id = programObj[key].block_id;

            if(block_id != tmp_block_id) {
                var day_order = programObj[key].day_order;
                var exercise  = programObj[key].exercise;
                tmpObj[ctr]   = {};

                //// Track and Reset Block Order Ctr when there's a new day ////
                if(tmp_day_order != day_order)
                    block_order_ctr = 1;
                else
                    block_order_ctr++

                //tmpObj[ctr].day_id        = day_id_tmp; // include day id so the first block in every day can be deleted
                tmpObj[ctr].week_id       = programObj[key].week_id;
                tmpObj[ctr].week_order    = programObj[key].week_order;
                tmpObj[ctr].day_id        = programObj[key].day_id;
                tmpObj[ctr].day_order     = day_order;
                // set new block order; if we use this - programObj[key].block_order - it contains old block orders which creates out of order blocks
                tmpObj[ctr].block_order   = block_order_ctr;
                tmpObj[ctr].block_id      = programObj[key].block_id;
                tmpObj[ctr].block_name    = programObj[key].block_name;
                tmpObj[ctr].exercise      = {}; //tmpObj[ctr].exercise = exercise;
                tmpObj[ctr].exercise_lgth = programObj[key].exercise_lgth;
                //console.log("programObj[key].day_id: " + programObj[key].day_id);
                //console.log("programObj[key].block_id: " + programObj[key].block_id);
                tmp_day_order = day_order;
                for(var key in exercise) {
                    var exer             = exercise[key];
                    var exer_name        = exer.name;
                    var exer_id          = exer.id;
                    var set_id           = exer.set_id;
                    var exer_order       = exer.order;
                    var notes            = exer.notes;
                    /*var advanced_metrics = exer.advanced_metrics;
                    var row_1_id         = exer.row_1_id;
                    var row_2_id         = exer.row_2_id;
                    var row_3_id         = exer.row_3_id;
                    var row_4_id         = exer.row_4_id;
                    var row_1_arr        = exer.row_1_arr;
                    var row_2_arr        = exer.row_2_arr;
                    var row_3_arr        = exer.row_3_arr;
                    var row_4_arr        = exer.row_4_arr;*/

                    tmpObj[ctr].exercise[key]        = {};
                    tmpObj[ctr].exercise[key].id     = exer_id;
                    tmpObj[ctr].exercise[key].name   = exer_name;
                    tmpObj[ctr].exercise[key].set_id = set_id;
                    tmpObj[ctr].exercise[key].order  = exer_order;
                    tmpObj[ctr].exercise[key].notes  = notes;

                    /*tmpObj[ctr].exercise[key].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];
                    tmpObj[ctr].exercise[key].row_1_id         = row_1_id;
                    tmpObj[ctr].exercise[key].row_2_id         = row_2_id;
                    tmpObj[ctr].exercise[key].row_3_id         = row_3_id;
                    tmpObj[ctr].exercise[key].row_4_id         = row_4_id;
                    tmpObj[ctr].exercise[key].row_1_arr        = row_1_arr;
                    tmpObj[ctr].exercise[key].row_2_arr        = row_2_arr;
                    tmpObj[ctr].exercise[key].row_3_arr        = row_3_arr;
                    tmpObj[ctr].exercise[key].row_4_arr        = row_4_arr;*/

                    /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
                }
                ctr++;
            }
    }

    return tmpObj;
}

export const deleteBlockObject = (programObj) => {
    var ctr = 0;
    var tmpObj = {}
    // Create New Object, Modify it, then Return it
    for(var key in programObj) {
        tmpObj[ctr] = {};
        tmpObj[ctr].block_order   = ctr;
        //tmpObj[ctr].day_id        = programObj[key].day_id;
        tmpObj[ctr].block_id      = programObj[key].block_id;
        tmpObj[ctr].block_name    = programObj[key].block_name;
        tmpObj[ctr].exercise      = programObj[key].exercise;
        tmpObj[ctr].exercise_lgth = programObj[key].exercise_lgth;

        //console.log("day_id: " + programObj[key].day_id);
        ctr++;
    }

    return tmpObj;
}

export const addNewBlock = (program) => {
    var block_lgth  = Object.keys(program).length;

    var block_order = block_lgth+1;

    // temp for category name creation
    var tmp = Math.ceil(Math.random() * (Math.ceil(6) - Math.floor(1)));

    // Add next Block in the object's order //
    var tmpBlockObj = {};
    tmpBlockObj[block_lgth] = {};
    //tmpBlockObj[block_lgth].category_id   = 0;//tmp; //no need
    tmpBlockObj[block_lgth].block_id      = uuidv1();
    tmpBlockObj[block_lgth].block_order   = block_order;
    tmpBlockObj[block_lgth].block_name    = "Block " + block_order;//this.tempGetCategory(tmp);
    tmpBlockObj[block_lgth].exercise_lgth = 0;
    tmpBlockObj[block_lgth].exercise      = {}; // new blocks need a default "exercise" property

    var blockObj = Object.assign(program, tmpBlockObj);//{[block_lgth]: tmp_block});

    return blockObj;
}

export const editExerciseObjectProps = (programObj, block_index, exercise_index, exercise_id, exercise_name, measure_a_id, measure_a_value, measure_b_id, measure_b_value, rest, notes) => {
    var ctr = 0;
    //var tmpObj = {}

    // Assign old object to new tmp object and delete Exercise sub-object
    programObj[block_index].exercise[exercise_index].id              = exercise_id;
    programObj[block_index].exercise[exercise_index].name            = exercise_name;
    /*programObj[block_index].exercise[exercise_index].measure_a_id    = measure_a_id;
    programObj[block_index].exercise[exercise_index].measure_a_value = measure_a_value;
    programObj[block_index].exercise[exercise_index].measure_b_id    = measure_b_id;
    programObj[block_index].exercise[exercise_index].measure_b_value = measure_b_value;
    programObj[block_index].exercise[exercise_index].rest            = rest;*/
    programObj[block_index].exercise[exercise_index].notes           = notes

    //return tmpObj;
}

export const editFreeFormObjectProps = (programObj, block_index, exercise_index, exercise_id, exercise_name, measure_a_id, measure_a_value, measure_b_id, measure_b_value, rest, notes) => {
    var ctr = 0;
    //var tmpObj = {}

    // Assign old object to new tmp object and delete Exercise sub-object
    programObj[block_index].exercise[exercise_index].id              = exercise_id;
    programObj[block_index].exercise[exercise_index].name            = exercise_name;
    /*programObj[block_index].exercise[exercise_index].measure_a_id    = measure_a_id;
    programObj[block_index].exercise[exercise_index].measure_a_value = measure_a_value;
    programObj[block_index].exercise[exercise_index].measure_b_id    = measure_b_id;
    programObj[block_index].exercise[exercise_index].measure_b_value = measure_b_value;
    programObj[block_index].exercise[exercise_index].rest            = rest;*/
    programObj[block_index].exercise[exercise_index].notes           = notes

    //return tmpObj;
}

export const editAdvancedExercise = (programObj, block_index, exercise_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes) => {
    var ctr = 0;

    //var tmpObj = {}
    // Assign old object to new tmp object and delete Exercise sub-object
    programObj[block_index].exercise[exercise_index].id               = exercise_id;
    programObj[block_index].exercise[exercise_index].name             = exercise_name;
    programObj[block_index].exercise[exercise_index].advanced_metrics = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
    programObj[block_index].exercise[exercise_index].row_1_id         = row_1_id;
    programObj[block_index].exercise[exercise_index].row_2_id         = row_2_id;
    programObj[block_index].exercise[exercise_index].row_3_id         = row_3_id;
    programObj[block_index].exercise[exercise_index].row_4_id         = row_4_id;
    programObj[block_index].exercise[exercise_index].row_1_arr        = row_1_arr;
    programObj[block_index].exercise[exercise_index].row_2_arr        = row_2_arr;
    programObj[block_index].exercise[exercise_index].row_3_arr        = row_3_arr;
    programObj[block_index].exercise[exercise_index].row_4_arr        = row_4_arr;
    programObj[block_index].exercise[exercise_index].exercise_notes   = exercise_notes;

    return programObj;
}

export const addNewFreeFormObject = (programObj, index, exercise_index, exercise_id, notes) => {
    var tmpBlockObj = programObj; // clone program obj
    var lgth = 0;
    // Add next Block in the object's order //
    tmpBlockObj[index].exercise_lgth                    = 1;
    //tmpBlockObj[index].exercise                       = {}; // need to remove otherwsie exercises stays at one ex per block
    tmpBlockObj[index].exercise[lgth]                   = {};
    tmpBlockObj[index].exercise[lgth].id                = exercise_id;
    tmpBlockObj[index].exercise[lgth].name              = "Free Form";
    tmpBlockObj[index].exercise[lgth].set_id            = uuidv1();
    tmpBlockObj[index].exercise[lgth].notes             = notes;
    tmpBlockObj[index].exercise[lgth].order             = 1;

    return tmpBlockObj;
}

export const addNewAdvancedExercise = (programObj, index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes) => {
    // ROW 4 is Always "REST" //
    var tmpBlockObj = programObj; // clone program obj
    var lgth        = programObj[index].exercise_lgth;
    //console.log("1. lgth: " + lgth);
    if(lgth == undefined) lgth = 0;

    var order       = lgth+1;
    /*console.log("-------------------------   addNewAdvancedExercise");
    console.log("order: " + order);
    console.log("exercise_id: " + exercise_id);
    console.log("1. exercise_name: " + exercise_name);*/
    /*console.log("row_1_arr: " + row_1_arr);
    console.log("row_2_arr: " + row_2_arr);
    console.log("row_3_arr: " + row_3_arr);
    console.log("row_4_arr: " + row_4_arr);*/

    // Add next Block in the object's order //
    tmpBlockObj[index].exercise_lgth                    = order;
    //tmpBlockObj[index].exercise                       = {}; // need to remove otherwsie exercises stays at one ex per block
    tmpBlockObj[index].exercise[lgth]                   = {};
    tmpBlockObj[index].exercise[lgth].id                = exercise_id;
    tmpBlockObj[index].exercise[lgth].name              = exercise_name;
    tmpBlockObj[index].exercise[lgth].set_id            = uuidv1();
    /*** New Rows ***/
    tmpBlockObj[index].exercise[lgth].advanced_metrics  = [row_1_arr,row_2_arr,row_3_arr,row_4_arr];//[[3,3,3],[30,30,30],[0,0,0],["00:30","00:30","00:30"]]
    tmpBlockObj[index].exercise[lgth].row_1_id          = row_1_id;
    tmpBlockObj[index].exercise[lgth].row_2_id          = row_2_id;
    tmpBlockObj[index].exercise[lgth].row_3_id          = row_3_id;
    tmpBlockObj[index].exercise[lgth].row_4_id          = row_4_id;
    tmpBlockObj[index].exercise[lgth].row_1_arr         = row_1_arr;
    tmpBlockObj[index].exercise[lgth].row_2_arr         = row_2_arr;
    tmpBlockObj[index].exercise[lgth].row_3_arr         = row_3_arr;
    tmpBlockObj[index].exercise[lgth].row_4_arr         = row_4_arr;
    tmpBlockObj[index].exercise[lgth].exercise_notes    = exercise_notes;

    return tmpBlockObj;
}



// WEBPACK FOOTER //
// ./src/utils/Object.js